// Shared PII masking helpers.

// Mask an Aadhaar number so only the last 4 digits are visible.
// 12-digit input → "XXXX-XXXX-1234". Falsy or malformed input → "-".
// We strip non-digits first so entries stored with spaces or hyphens (e.g.
// "1234 5678 9012") still render consistently.
export function maskAadhaar(value) {
  const digits = String(value || "").replace(/\D/g, "");
  if (digits.length < 4) return "-";
  return `XXXX-XXXX-${digits.slice(-4)}`;
}
